import { useCatalog } from '../../contexts/CatalogContext';
import { useSite } from '../../contexts/SiteContext';
import { tierIn } from '../../data/gifts';
import { euro } from '../../core/format/currency';

/** Snel vergelijken — vergelijkende inhoud hoort in een tabel. */
export function RoutineCompare({
  heading
}: {
  heading: string;
}) {
  const {
    routines,
    routineTotals
  } = useCatalog();
  const {
    giftTiers
  } = useSite();
  // Vergelijken kan pas vanaf twee protocollen; anders een tabel met één (of nul) rijen.
  if (routines.length < 2) return null;
  return <div className="mt-16 min-w-0" data-id="element-8278" data-mp="3dhfmwrf6se3q">
      <h3 id="routine-compare" className="font-display text-[1.75rem] font-light text-ink" data-id="element-8279" data-mp="3i9qnzxlny5xv">
        {heading}
      </h3>
      {/* Scrollbaar op mobiel; met het toetsenbord bereikbaar zodat je ook zonder muis kunt schuiven. */}
      <div className="-mx-6 mt-6 overflow-x-auto px-6 lg:mx-0 lg:px-0" tabIndex={0} role="region" aria-labelledby="routine-compare" data-id="element-8280" data-mp="3s8pr70nnt9dh">
        <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-8281" data-mp="4dpsgfcv6nj">
          <caption className="sr-only" data-id="element-8282" data-mp="1rundv3mno6i5">{heading}: per protocol voor wie, hoe lang, welk cadeau en de prijs</caption>
          <thead data-id="element-8283" data-mp="1msxzbe085apb">
            <tr className="border-b border-ink/25 text-[13px] text-muted" data-id="element-8284" data-mp="1mwluehlbi565">
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8285" data-mp="1hvy2ltp9lkav">
                Protocol
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8286" data-mp="1cy60y7ytijth">
                Voor wie
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8287" data-mp="2am6bsw1toudb">
                Gaat mee
              </th>
              <th scope="col" className="py-3 pr-6 font-normal" data-id="element-8288" data-mp="25ncyb3mjd3d5">
                Cadeau
              </th>
              <th scope="col" className="py-3 text-right font-normal" data-id="element-8289" data-mp="1vv773w43ypz0">
                Prijs
              </th>
            </tr>
          </thead>
          <tbody data-id="element-8290" data-mp="2tbmoehqs8da3">
            {routines.map(r => {
            const t = routineTotals(r);
            const gift = tierIn(giftTiers, t.price);
            return <tr key={r.id} className="border-b border-line align-top text-[15px]" data-id="element-8291" data-mp="mlsuskhsrs5l">
                  <th scope="row" className="py-4 pr-6 font-display font-normal text-ink" data-id="element-8292" data-mp="rl5sk0a7ijmy">
                    {r.name}
                  </th>
                  <td className="py-4 pr-6 text-muted" data-id="element-8293" data-mp="cvq44qy5eqaf">{r.forWho}</td>
                  <td className="whitespace-nowrap py-4 pr-6 text-muted" data-id="element-8294" data-mp="hv2maye2r96o">{t.months}</td>
                  <td className="py-4 pr-6 text-muted" data-id="element-8295" data-mp="3w2zlwa4h4d5">
                    {gift ? gift.title : <>
                        <span aria-hidden="true" data-id="element-8296" data-mp="7v3gh991hwxi">—</span>
                        <span className="sr-only" data-id="element-8297" data-mp="3q4cozsk1d831">Geen cadeau</span>
                      </>}
                  </td>
                  <td className="whitespace-nowrap py-4 text-right font-display tabular-nums text-ink" data-id="element-8298" data-mp="3v48jn16ufn5x">{euro(t.price)}</td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
}